import lazyLoading from './lazyLoading'

export default {
  name: 'Terms Filter',
  system: 'terms_filter',
  path: '/termsFilter',
  meta: {
    auth: true,
    icon: 'fa-filter',
    link: 'termsFilter/index.vue',
    label: 'Terms Filter',
    expanded: false
  },
  component: lazyLoading('termsFilter', true)
}
